import React, { createContext, useContext, useEffect, useState } from "react";

const AppContext = createContext(null);

const DEFAULT_INVOICE = {
  company: { name: "", logo: "", address: "", gst: "", email: "", phone: "", website: "" },
  customer: { name: "", address: "", email: "", phone: "" },
  meta: {
    number: "INV-0001",
    date: new Date().toISOString().slice(0, 10),
    dueDate: new Date(Date.now() + 14 * 86400000).toISOString().slice(0, 10),
    currency: "USD",
    language: "en",
  },
  items: [{ name: "", description: "", qty: 1, price: 0, discount: 0, tax: 0 }],
  discountPct: 0,
  taxPct: 0,
  shipping: 0,
  payments: { cash: false, upi: true, bank: true, card: false, paypal: false },
  notes: "Thank you for your business!",
  terms: "Payment due within 14 days.",
  signature: "",
};

export function AppProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("si-theme") || "light");
  const [invoice, setInvoice] = useState(() => {
    try {
      const saved = localStorage.getItem("si-invoice");
      return saved ? JSON.parse(saved) : DEFAULT_INVOICE;
    } catch {
      return DEFAULT_INVOICE;
    }
  });

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("si-theme", theme);
  }, [theme]);

  useEffect(() => {
    localStorage.setItem("si-invoice", JSON.stringify(invoice));
  }, [invoice]);

  const toggleTheme = () => setTheme((t) => (t === "dark" ? "light" : "dark"));
  const resetInvoice = () => setInvoice(DEFAULT_INVOICE);

  return (
    <AppContext.Provider value={{ theme, toggleTheme, invoice, setInvoice, resetInvoice }}>
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
export { DEFAULT_INVOICE };
